import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { MilestonesGetResultApi } from 'api-typings/projects/projects';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    milestones: MilestonesGetResultApi;
  }
}

export const milestonesBackend: Backend<'milestones'> = {
  fetch: (_, key2, query) => ({
    endpoint: `projects/0.1/milestones`,
    params: {
      projects: query ? getQueryParamValue(query, 'projectId') : [],
      bids: query ? getQueryParamValue(query, 'bidId') : [],
    },
  }),
  post: () => ({
    endpoint: `projects/0.1/milestones/`,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestones/milestones.backend.ts